<div class="row d-flex justify-content-end">
    <a class="btn btn-sm btn-dark mr-5" [routerLink]="['/admin_panel/porfilo_buckets']" routerLinkActive="router-link-active" >Back</a>
</div>

<div style="margin-right: 32px;">
  <div>
      <h4 class="title" style="margin-top: 15px;">Allocation List</h4>
  </div>
</div>

<div class="card" style="padding: 10px; border-radius:10px;">
</div>



<br>

<div style="margin: 2px;padding-bottom: 15px;">

  <div class="row">
      <div class="col-12">
          <!-- <p>User Account : &nbsp; &nbsp; <b>{{saved_Fields.length}}</b></p> -->
        </div>

      <div class="col-md-12">
          <div>
              <button (click)="next_rec()">Next 1,000 rec</button>
              <button (click)="pre_rec()">Last 1,000 rec</button>

             
          <h4 class="title-f">New Accounts</h4>
          <h4 class="title-f">{{count}}</h4>

         <div class="animate" *ngIf="!loading">

         </div>
          <div *ngIf="loading" >
           
      <div class="card-box"> <p-table [value]="saved_Fields | filterBy:userFilter" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="25"
          [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [globalFilterFields]="['type']">
          <ng-template pTemplate="header">
              <tr class="thhead">

                  <th class="th-1">
                      S.No
                  </th>
                  <th>
                    Bank
                 </th>
                  <th>
Portfolio
                  </th>
                  <th>
                     Bucket 
                  </th>
                  <th>
                    Acc no
                  </th>
                  <th>
                    Passport
                  </th>
                  <th>
                   Finterstal
                  </th>
                  <th>
                    Assigned to
                  </th>
                  <th>
                    Assigned by
                  </th>
                 
                  <th>
                   Date of Assign
                  </th>
                  <th>
                    Out Standing
                   </th>
                   <th>
                   Update At
                   </th>

                  <th style="width: 110px;text-align:center">
                      More Details
                  </th>
              </tr>
              <tr>
                  <th></th>
                  <th>  </th>
                  <th> </th>
                  <th> <input class="form-control" type="text" (change)="bucket($event)"></th>
                  <th> <input class="form-control" type="text" (change)="accno($event)"></th>
                  <th> <input class="form-control" type="text" (change)="passport($event)"></th>
                  <th> <input class="form-control" type="text" (change)="fint($event)"></th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                  <th> </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr class="tdrow"  >
                  <td>{{i+1}}</td>
                

                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">
                    <select [(ngModel)]="item.bank_name" style="width: 100%;" disabled>
                   <option *ngFor="let item of origianl_bank_list" [value]="item._id">{{item.bank_name}}</option>
                   </select>
                  </td>

                 <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">
                   <select [(ngModel)]="item.portfolio" style="width: 100%;" disabled>
                       <option *ngFor="let item of original_portfolio_list" [value]="item._id">{{item.portfolio_type}}</option>
                   </select>
                 </td>


            


                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.bucket }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.acc_no }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.passport }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.fint }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.alloc_to }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">
                    <select [(ngModel)]="item.alloc_by" style="width: 100%;" disabled>
                        <option *ngFor="let item of user_list_details" [value]="item._id">{{item.email_id}}</option>
                    </select>
                  </td>

                  


                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.date_of_assign | date }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.total_outstanding }}</td>
                  <td (click)="getCustomer('/admin_panel/user/createuser?_id='+item.finterstal_id,item)">{{item.last_update | date }}</td>
                  <td class="act" (click)="delete_allocation(item.id)">
                      <i style="color: #4CAF50;" class="fa fa-trash" aria-hidden="true" pTooltip="Delete Account"></i>
                  </td>
              </tr>
          </ng-template>
       </p-table>  
      </div>
          </div>
        </div>
      </div>

  </div>





  
</div>
